import apiClient, { unwrap } from './client';
import { historyStart } from '../utils/historyWindow';
import { cache, CACHE_TAGS } from '../utils/cache';

export const salesApi = {
  getAll: async (from = historyStart()) => {
    const res = await apiClient.get('/sales', { params: { size: 1000, sort: 'date,desc', ...(from ? { from } : {}) } });
    const page = unwrap(res);
    return page?.content ?? page ?? [];
  },

  create: async (sale) => {
    const res = await apiClient.post('/sales', sale);
    if (sale?.type === 'animal') cache.invalidateByTag(CACHE_TAGS.DAIRY_ANIMALS); // the sold animal becomes SOLD
    if (sale?.type === 'milk') cache.invalidateByTag(CACHE_TAGS.MILK_STOCK);
    return unwrap(res);
  },

  update: async (id, sale) => {
    const res = await apiClient.put(`/sales/${id}`, sale);
    if (sale?.type === 'animal') cache.invalidateByTag(CACHE_TAGS.DAIRY_ANIMALS);
    if (sale?.type === 'milk') cache.invalidateByTag(CACHE_TAGS.MILK_STOCK);
    return unwrap(res);
  },

  remove: async (id) => {
    await apiClient.delete(`/sales/${id}`);
    cache.invalidateByTag(CACHE_TAGS.DAIRY_ANIMALS); // type unknown here; deleting an animal sale can restore the animal
    // Milk sales debit the stock ledger — invalidate broadly since type isn't known here.
    cache.invalidateByTag(CACHE_TAGS.MILK_STOCK);
  },

  getHistory: async (from, to, periodType) => {
    const res = await apiClient.get('/sales/history', {
      params: { from, to, periodType }
    });
    return unwrap(res);
  },
};
